<template>
  <el-table-column
    prop="currency.name"
    label="Deviza"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.currency.name }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'currency.name',
  };
</script>
